// ./client/src/components/labEngine/PyodideContext.jsx

import React, { createContext, useContext, useEffect, useState, useRef } from 'react';

const PyodideContext = createContext(null);

export const PyodideProvider = ({ children }) => {
  console.log('🔍 PyodideProvider mounting');
  const [pyodide, setPyodide] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const stdoutBuffer = useRef([]);

  useEffect(() => {
    const loadPyodide = async () => {
      try {
        // const script = document.createElement('script');
        // script.src = 'https://cdn.jsdelivr.net/pyodide/v0.25.0/full/pyodide.js';
        // document.head.appendChild(script);

        // await new Promise((resolve, reject) => {
        //   script.onload = () => resolve();
        //   script.onerror = () => reject(new Error('Failed to load Pyodide'));
        // });

        // REPLACE with just:
        const py = await window.loadPyodide({
          indexURL: 'https://cdn.jsdelivr.net/pyodide/v0.25.0/full/',
          stdout: (text) => stdoutBuffer.current.push(text),
          stderr: (text) => stdoutBuffer.current.push(`[stderr] ${text}`),
        });

        await py.loadPackage(['numpy', 'pandas', 'matplotlib', 'scikit-learn']);

        await py.runPythonAsync(`
import matplotlib
matplotlib.use('Agg')
import matplotlib.pyplot as plt
import io, base64

def _get_plot_base64():
    buf = io.BytesIO()
    plt.savefig(buf, format='png', bbox_inches='tight', dpi=120)
    buf.seek(0)
    img_str = base64.b64encode(buf.read()).decode('utf-8')
    plt.close('all')
    return img_str
`);

        setPyodide(py);
      } catch (err) {
        setError(err.message || 'Failed to initialize Python environment');
      } finally {
        setIsLoading(false);
      }
    };

    loadPyodide();
  }, []);

  const runCode = async (code) => {
    if (!pyodide) {
      return { stdout: '', stderr: '', result: null, plot: null, error: 'Python not ready' };
    }

    stdoutBuffer.current = [];
    let plot = null;
    let errorMsg = null;

    try {
      await pyodide.runPythonAsync(code);

      const hasFig = await pyodide.runPythonAsync(`
import matplotlib.pyplot as plt
len(plt.get_fignums()) > 0
`);

      if (hasFig) {
        plot = await pyodide.runPythonAsync(`_get_plot_base64()`);
      }
    } catch (err) {
      errorMsg = err.message || String(err);
      if (errorMsg.includes('PythonError')) {
        const match = errorMsg.match(/PythonError: ([\s\S]+)/);
        errorMsg = match ? match[1] : errorMsg;
      }
    }

    const allStdout = stdoutBuffer.current.filter(l => !l.startsWith('[stderr]')).join('\n');
    const allStderr = stdoutBuffer.current.filter(l => l.startsWith('[stderr]')).map(l => l.replace('[stderr] ', '')).join('\n');

    return { stdout: allStdout, stderr: allStderr, plot, error: errorMsg };
  };

  return (
    <PyodideContext.Provider value={{ pyodide, isLoading, error, runCode }}>
      {children}
    </PyodideContext.Provider>
  );
};

export const usePyodide = () => {
  const ctx = useContext(PyodideContext);
  if (!ctx) throw new Error('usePyodide must be used inside PyodideProvider');
  return ctx;
};
